import { DualPrice, Price, SinglePrice, formatPrice } from 'modules/proposals';
import React from 'react';

interface Props {
  currency: string;
  totalPrice: number;
  exchangeRate?: number;
  dualCurrency?: string;
  ISOCountry?: string;
}

export const TotalPublicServiceSegmentCardPrice: React.FC<Props> = ({
  currency,
  totalPrice,
  exchangeRate,
  dualCurrency = 'eur',
  ISOCountry,
}) => (
  <Price
    currency={currency}
    dualCurrency={dualCurrency}
    customExchangeRate={exchangeRate}
    dualPriceElement={
      <DualPrice>
        <p className="t-eta">{formatPrice(totalPrice, currency, ISOCountry)}</p>
        {exchangeRate && (
          <p className="o-60 text--xxs__responsive">
            {formatPrice(totalPrice * exchangeRate, dualCurrency, ISOCountry)}
          </p>
        )}
      </DualPrice>
    }
    singlePriceElement={
      <SinglePrice className="t-eta">
        {formatPrice(totalPrice, currency, ISOCountry)}
      </SinglePrice>
    }
  />
);
